import * as React from "react";
import { IPatientConcern } from "@curefit/ehr-common";
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import * as _ from "lodash"
import ModelFactory from "../../models/ModelFactory"
import {PatientConcernViewProps} from "../../components/patient/view/PatientConcernView";
import {PatientConcernEditorProps} from "../../components/patient/edit/PatientConcernEditor";
import IEditedBy from "../../models/IEditedBy";
import {SourceConstants} from "../../utils/AppConstants";
import ErrorContainer from "./../ErrorContainer";
import {ITypeFormQuestionnaire} from "../../models/ITypeFormQuestionnaire";

/**
 * Created by aditya on 28/02/18.
 */

export interface ConcernsEditViewContProps {
    appointmentId?: number,
    editedBy: IEditedBy,
    titleToDisplay?: string,
    patientId: number,
    patientConcerns: IPatientConcern[],
    displayMode?: EditViewDisplayMode,
    fetchPatientConcerns?: (patientId: number) => any,
    fetchStaticSymptomData?: (input: string) => Promise<any>,
    savePatientConcerns?: (patientId: number, patientConcern: IPatientConcern[]) => any,
    questionnaire?: ITypeFormQuestionnaire[];
    typeFormMapping?: any;
}

export interface ConcernsEditViewContState {
    updatedConcerns: {item: IPatientConcern}[],
    isPatientConcernDataLoaded: LOADING_STATE,
    error: string,
    errorDetails: string
}

class ConcernsEditViewCont extends React.Component<ConcernsEditViewContProps, ConcernsEditViewContState> {

    constructor(props: ConcernsEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(props: ConcernsEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }

    getUpdatedConcernsFromProps = (props: ConcernsEditViewContProps): {item: IPatientConcern}[] => {
        let currUpdatedConcerns: {item: IPatientConcern}[] = [];
        _.map(props.patientConcerns, function(concern){
            let clonePatientConcern = Object.assign({}, concern);
            currUpdatedConcerns.push({item: clonePatientConcern});
        });
        return currUpdatedConcerns;
    }

    getStateFromProps = (props: ConcernsEditViewContProps) => {
        let currState: ConcernsEditViewContState = {
            updatedConcerns: [],
            isPatientConcernDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            error: this.state ? this.state.error : "",
            errorDetails: this.state ? this.state.errorDetails : ""
        }
        if ( _.isNull(props.patientConcerns) ) {
            props.fetchPatientConcerns(this.props.patientId);
            currState.isPatientConcernDataLoaded = LOADING_STATE.LOADING;
        } else {
            currState.updatedConcerns = [];
            if (!_.isEmpty(props.patientConcerns)) {
                _.map(props.patientConcerns, function(patientConcern){
                    let clonePatientConcerns = Object.assign({}, patientConcern);
                    currState.updatedConcerns.push({item: clonePatientConcerns});
                });
            }
            currState.isPatientConcernDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }

    getConcernEditViewTemplateProps = () => {
        let patientConcernViewProps: PatientConcernViewProps = {
            concerns: this.props.patientConcerns,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        let patientConcernEditorProps: PatientConcernEditorProps = {
            updatedConcerns: this.state.updatedConcerns,
            updateConcerns: this.updatePatientConcern,
            fetchStaticSymptomData: this.props.fetchStaticSymptomData,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        return {"view": patientConcernViewProps, "edit": patientConcernEditorProps};
    }

    updatePatientConcern = (updatedConcerns: {item: IPatientConcern}[]) => {
        this.setState({updatedConcerns});
    }

    savePatientConcern = () => {
        let myInstance = this;
        let saveConcernsList: IPatientConcern[] = this.getSaveObject();
        // if (saveConcernsList.length > 0) {
        if (this.isFormDirty()) {
            this.setState({
                error: "Cannot save Concerns",
                errorDetails: "Please fill in all the mandatory fields before proceeding"
            })
        } else {
            this.setState({isPatientConcernDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientConcerns(this.props.patientId, saveConcernsList).then(function(){
                myInstance.setState({isPatientConcernDataLoaded: LOADING_STATE.LOADED})
            });
        }
        // }
    }

    cancelActionHandler = () => {
        this.setState({updatedConcerns: this.getUpdatedConcernsFromProps(this.props)});
    }

    getSaveObject = (): IPatientConcern[] => {
        let myInstance = this;
        let saveConcernsList: IPatientConcern[] = [];
        _.map(this.state.updatedConcerns, function(updatedConcernItem: {item: IPatientConcern}){
            // if (ModelFactory.isValidConcern(updatedConcernItem.item)) {
            let updatedConcernItemForSave = AppUtils.sanitizeRequestItemBeforeSave(updatedConcernItem.item);
            updatedConcernItemForSave.lastEditedPersonId = parseInt(myInstance.props.editedBy.id);
            updatedConcernItemForSave.personType = myInstance.props.editedBy.role.toLowerCase();
            updatedConcernItemForSave.source = SourceConstants.DOCSASPP;
            updatedConcernItemForSave.appointmentId = myInstance.props.appointmentId;
            updatedConcernItemForSave.patientId = myInstance.props.patientId;
            updatedConcernItemForSave.isDeleted = false;
            saveConcernsList.push(updatedConcernItemForSave);
            // }
        });
        return saveConcernsList;
    }

    isFormDirty = (): boolean => {
        let status = false;
        _.map(this.state.updatedConcerns, function(updatedConcernItem: {item: IPatientConcern}){
            if (!ModelFactory.isValidConcern(updatedConcernItem.item)) {
                status = true;
                return false;
            }
        })
        return status;
    }

    typeFormQuestionIdList = (): string[] => {
        let questionList = [];
        questionList = this.props.typeFormMapping.filter(item => item.group === "WORRIES");
        if (!_.isEmpty(questionList)) {
            questionList = questionList.map(item => item.code);
        }
        return questionList;
    }

    clearErrorMessage = () => {
        this.setState({
            error: "",
            errorDetails: ""
        })
    }

    render() {
        let isConcernDataLoaded =  this.state.isPatientConcernDataLoaded === LOADING_STATE.LOADED;
        let errorMessage = !_.isEmpty(this.state.error) ? this.state.error : null;
        let errorDetails = !_.isEmpty(this.state.errorDetails) ? this.state.errorDetails : "";
        let title = !_.isEmpty(this.props.titleToDisplay) ? this.props.titleToDisplay : "Long term patient worries";
        return (
            <div className="symptom-editview-cont">
                {
                    !_.isNull(errorMessage) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}/>
                }
                {
                    isConcernDataLoaded &&
                    <EditViewCard cardTitleDisplay={title} templateName={"concern"}
                                  templateProps={this.getConcernEditViewTemplateProps()}
                                  lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientConcern}
                                  cancelActionHandler={this.cancelActionHandler}
                                  displayMode={this.props.displayMode}
                    />
                }
                {
                    !isConcernDataLoaded &&
                    <AppLoader/>
                }
            </div>
        );
    }
}

export default ConcernsEditViewCont